var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TaskList',{attrs:{"title":"Financial Document","taskType":"financial_document"}})
}
var staticRenderFns = []

export { render, staticRenderFns }